export default class Person {
  userId;
  extSysApiUserId;
  name;
  emailSchoolAddress;

  constructor(apiPerson) {
    if (apiPerson) {
      this.userId = apiPerson.userId;
      this.extSysApiUserId = apiPerson.extSysApiUserId;
      this.name = apiPerson.name;
      this.emailSchoolAddress = apiPerson.emailSchoolAddress;
    }
  }
}
